import React from "react";
import { Box, Typography } from "@mui/material";
import { CheckCircleOutline } from "@mui/icons-material";
import BrainIcon from "../../../../assets/brain.svg";
import LightningIcon from "../../../../assets/lightning.svg";
import AnimatedOrb from "../AnimatedOrb";
import SpeechBubble from "../SpeechBubble";

/**
 * Lets the user choose between Adaptive and Priority sorting approaches.
 * Mirrors the WelcomePanel from FirstVisitOfTheDay, but themed for the guide.
 */
const ApproachStep = ({ selected, onSelect }) => {
  return (
    <Box className="task-guide-step task-guide-step--approach">
      <AnimatedOrb size="medium" intensity="idle" />
      <SpeechBubble>
        <Typography variant="body1" sx={{ margin: 0, textAlign: "center" }}>
          How would you like to approach your tasks today?
        </Typography>
      </SpeechBubble>

      <Box className="task-guide-step__approach-options">
        <Box
          className={`task-guide-step__approach-card ${selected === "adaptive" ? "task-guide-step__approach-card--selected" : ""}`}
          onClick={() => onSelect("adaptive")}
        >
          <CheckCircleOutline
            className="task-guide-step__approach-check"
            fontSize="large"
          />
          <Typography variant="h3" sx={{ marginBottom: 0 }}>
            Adaptive
          </Typography>
          <img
            src={BrainIcon}
            className="task-guide-step__approach-icon"
            alt="Adaptive"
          />
          <Typography variant="body2">
            Suggest tasks based on how you're feeling today
          </Typography>
        </Box>

        <Box
          className={`task-guide-step__approach-card ${selected === "priority" ? "task-guide-step__approach-card--selected" : ""}`}
          onClick={() => onSelect("priority")}
        >
          <CheckCircleOutline
            className="task-guide-step__approach-check"
            fontSize="large"
          />
          <Typography variant="h3" sx={{ marginBottom: 0 }}>
            Efficient
          </Typography>
          <img
            src={LightningIcon}
            className="task-guide-step__approach-icon"
            alt="Priority"
          />
          <Typography variant="body2">
            Prioritize the tasks that are most important to you
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ApproachStep;
